import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'

import DevicesWrapper from '../component/services/devices-wrapper'

// import { formatCurrency } from '../utils/functions'
import Package from '../component/services/package'
import PackageSuppl from '../component/services/package-suppl'
import PackageOther from '../component/services/package-other'

import sanitizeHtml from 'sanitize-html'
import { renderError } from '../utils/form'
import { ALLOWED_ATTRIBUTES, ALLOWED_TAGS } from '../conf/constants'

const UpsellListWrapper = ({ label, desc, children, type }) => {
  return (
    <React.Fragment>
      <h2 className="h2">{label}</h2>
      <p className={'services__subtitle'}>{desc}</p>
      <div className={type + ' offer-step--1'}>{children}</div>
    </React.Fragment>
  )
}

const PortfolioListWrapper = ({
  label,
  desc,
  labelActionText,
  labelTextAction,
  labelSuffix,
  descActionText,
  descTextAction,
  descSuffix,
  children,
}) => {
  return (
    <React.Fragment>
      <div className="portfolio__content__text portfolio__content__text--lonely">
        {label} <u onClick={labelTextAction}>{labelActionText}</u>
        {labelSuffix}
      </div>
      <div className={'portfolio__content__item__wrap offer-step--1'}>
        {children}
      </div>
      <p className={'portfolio__content__info'}>
        {desc} <u onClick={descTextAction}>{descActionText}</u>
        {descSuffix}
      </p>
    </React.Fragment>
  )
}

class ServiceUpsellForm extends Component {
  componentDidMount() {
    if (this.props.selectedPackageCore)
      this.props.change('package_core', this.props.selectedPackageCore)

    try {
      const option =
        this.props.options && this.props.options[this.props.selectedPortfolio]
      Object.values(option.other).forEach((o) => {
        if (o.required && o.selected) {
          this.props.change(`package_other[${o.group}]`, true)
        }
      })
    } catch (error) {}
  }

  render() {
    const {
      options,
      portfolios,
      handleSubmit,
      handleServices,
      handleInstallation,
      handleSubmitStep1,
      submitting,
      toggleModal,
      selectPortfolio,
      selectedPortfolio,
      selectedInstallation,
      // selectedPackageCore,
      content,
      change,
      portfolioKey,
      deviceTotal,
      formData,
    } = this.props

    const option = (options &&
      selectedPortfolio &&
      options[selectedPortfolio]) || {
      core: {},
      suppl: {},
      other: {},
      device: {},
      installation: {},
    }

    const core = Object.values(option.core).filter((i) => !i.private)
    const suppl = Object.values(option.suppl).filter((i) => !i.private)
    const other = Object.values(option.other).filter((i) => !i.private)
    const devices = Object.values(option.device).filter((i) => !i.private)
    const installations = Object.values(option.installation)

    return (
      <form onSubmit={handleSubmit(handleSubmitStep1)}>
        {core && (
          <UpsellListWrapper
            label={sanitizeHtml(
              content[`content.new.contract.${portfolioKey}.packages.title`],
              {
                allowedTags: [],
                allowedAttributes: [],
              }
            )}
            desc={sanitizeHtml(
              content[
                `content.new.contract.${portfolioKey}.packages.description`
              ],
              {
                allowedTags: [],
                allowedAttributes: [],
              }
            )}
            type={'packages'}
          >
            <Field name="package_core" component={renderError} />
            {core.map((item) => (
              <Package
                key={item.group}
                item={item}
                toggleModal={toggleModal}
                tag={
                  content[
                    `content.new.contract.${portfolioKey}.${item.group}.tag`
                  ]
                    ? sanitizeHtml(
                        content[
                          `content.new.contract.${portfolioKey}.${item.group}.tag`
                        ],
                        { allowedAttributes: [], allowedTags: [] }
                      )
                    : null
                }
                channelCount={
                  content[
                    `content.new.contract.${portfolioKey}.${item.group}.channel_count`
                  ]
                    ? sanitizeHtml(
                        content[
                          `content.new.contract.${portfolioKey}.${item.group}.channel_count`
                        ],
                        { allowedAttributes: [], allowedTags: [] }
                      )
                    : null
                }
                channels={
                  content[
                    `content.new.contract.${portfolioKey}.${item.group}.channels`
                  ]
                    ? sanitizeHtml(
                        content[
                          `content.new.contract.${portfolioKey}.${item.group}.channels`
                        ],
                        {
                          allowedAttributes: ALLOWED_ATTRIBUTES,
                          allowedTags: ALLOWED_TAGS,
                        }
                      )
                    : null
                }
                selectPackage={() => {
                  handleServices(item.group, 'core')
                  change(`package_core`, item.group)
                }}
                // description={
                //   '<div class="channel__list"><h2>Všeobecné</h2><div><span><img alt="Telly" src="https://moje.telly.cz/img/channel-premier-sport-2-60.png"><span><strong>Premier Sport HD</strong></span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-1-3-60.png"><span>Digi Sport 1 HD</span></span> <span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-2-2-60.png"><span>Digi Sport 2 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-3-2-60.png"><span>Digi Sport 3 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-6-2-60.png"><span>Digi Sport 6 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-7-2-60.png"><span>Digi Sport 7 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-8-2-60.png"><span>Digi Sport 8 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-digi-sport-9-2-60.png"><span>Digi Sport 9 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-nova-sport-1-60.png"><span>Nova sport 1 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-nova-sport-2-60.png"><span>Nova sport 2 HD</span></span> <span><img alt="Telly" src="https://moje.telly.cz/img/channel-eurosport-1-3-60.png"><span>Eurosport 1 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-eurosport-2-3-60.png"><span>Eurosport 2 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-arena-sport-1-60.png"><span>Arena Sport 1 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-arena-sport-2-60.png"><span>Arena Sport 2 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-fightbox-60.png"><span>FightBox HD</span></span> <span><img alt="Telly" src="https://moje.telly.cz/img/channel-golf-60.png"><span>Golf Channel</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-ct-sport-60.png"><span>ČT sport HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-ct1-60.png"><span>ČT 1 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-ct2-60.png"><span>ČT 2 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-ct3-60.png"><span>ČT 3 HD</span></span><span><img alt="Telly" src="https://moje.telly.cz/img/channel-ct24-60.png"><span>ČT 24 HD</span></span></div></div>'
                // }
                description={sanitizeHtml(
                  content[
                    `content.new.contract.${portfolioKey}.${item.group}.description`
                  ],
                  {
                    allowedTags: ALLOWED_TAGS,
                    allowedAttributes: ALLOWED_ATTRIBUTES,
                  }
                )}
              />
            ))}
          </UpsellListWrapper>
        )}

        {suppl && (
          <UpsellListWrapper
            label={sanitizeHtml(
              content[`content.new.contract.${portfolioKey}.suppl.title`],
              { allowedTags: [], allowedAttributes: [] }
            )}
            desc={sanitizeHtml(
              content[`content.new.contract.${portfolioKey}.suppl.description`],
              { allowedTags: [], allowedAttributes: [] }
            )}
            type={'supplementary-packages'}
          >
            {suppl.map((item) => (
              <PackageSuppl
                key={item.group}
                item={item}
                channels={
                  content[
                    `content.new.contract.${portfolioKey}.${item.group}.channels`
                  ]
                    ? sanitizeHtml(
                        content[
                          `content.new.contract.${portfolioKey}.${item.group}.channels`
                        ],
                        {
                          allowedAttributes: ALLOWED_ATTRIBUTES,
                          allowedTags: ALLOWED_TAGS,
                        }
                      )
                    : null
                }
                toggleModal={() =>
                  toggleModal(
                    sanitizeHtml(
                      content[
                        `content.new.contract.${portfolioKey}.${item.group}.description`
                      ],
                      {
                        allowedTags: ALLOWED_TAGS,
                        allowedAttributes: ALLOWED_ATTRIBUTES,
                      }
                    )
                  )
                }
              >
                <Field
                  name={`package_suppl[${item.group}]`}
                  type="checkbox"
                  className={`list__input`}
                  component="input"
                  onClick={() => handleServices(item.group)}
                  disabled={item.disabled}
                  checked={item.selected}
                />
              </PackageSuppl>
            ))}
          </UpsellListWrapper>
        )}
        <div className={'portfolio'}>
          <h2 className="h2">
            {sanitizeHtml(content['content.new.contract.portfolio.title'], {
              allowedTags: [],
              allowedAttributes: [],
            })}
          </h2>
          <p className={'services__subtitle'}>
            {sanitizeHtml(
              content[
                `content.new.contract.${portfolioKey}.reception.description`
              ],
              {
                allowedTags: [],
                allowedAttributes: [],
              }
            )}
          </p>
          <div className={'portfolio__options'}>
            {portfolios &&
              portfolios.map((portfolio) => (
                <button
                  type="button"
                  className={`portfolio__options__item ${
                    selectedPortfolio === portfolio.id &&
                    'portfolio__options__item--selected'
                  }`}
                  key={portfolio.id}
                  onClick={() => {
                    selectPortfolio(portfolio.id)
                    // change('device', null)
                  }}
                >
                  {sanitizeHtml(
                    content[
                      `content.new.contract.portfolio.${portfolio.group}.name`
                    ],
                    {
                      allowedTags: [],
                      allowedAttributes: [],
                    }
                  )}
                </button>
              ))}
          </div>
          <div className={'portfolio__content'}>
            {other && (
              <PortfolioListWrapper
                label={sanitizeHtml(
                  content[`content.new.contract.${portfolioKey}.other.title`],
                  {
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                )}
                desc={sanitizeHtml(
                  content[
                    `content.new.contract.${portfolioKey}.other.description`
                  ],
                  {
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                )}
                labelActionText={sanitizeHtml(
                  content[
                    `content.new.contract.${portfolioKey}.other.title.modaltext`
                  ],
                  {
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                )}
                labelTextAction={() =>
                  toggleModal(content[`content.new.contract.tellyapps.modal`])
                }
                labelSuffix={sanitizeHtml(
                  content[
                    `content.new.contract.${portfolioKey}.other.title.suffix`
                  ],
                  {
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                )}
                descActionText={sanitizeHtml(
                  content[
                    `content.new.contract.${portfolioKey}.other.description.modaltext`
                  ],
                  {
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                )}
                descTextAction={() =>
                  toggleModal(content[`content.new.contract.tellyapps.modal`])
                }
                descSuffix={sanitizeHtml(
                  content[
                    `content.new.contract.${portfolioKey}.other.description.suffix`
                  ],
                  {
                    allowedTags: [],
                    allowedAttributes: [],
                  }
                )}
              >
                {other.map((item) => (
                  <PackageOther
                    key={item.group}
                    item={item}
                    toggleModal={toggleModal}
                    modalContent={
                      item.group === 'MULTISCREEN' &&
                      content[`content.new.contract.tellyapps.modal`]
                    }
                  >
                    <Field
                      name={`package_other[${item.group}]`}
                      type="checkbox"
                      className={`list__input`}
                      component="input"
                      onClick={() => handleServices(item.group)}
                      disabled={
                        item.disabled || (item.required && item.selected)
                      }
                      checked={item.selected}
                      required={item.required}
                    />
                  </PackageOther>
                ))}
              </PortfolioListWrapper>
            )}
            <hr />
            <h3 className={'portfolio__content__text'}>
              {sanitizeHtml(
                content[`content.new.contract.${portfolioKey}.devices.title`],
                {
                  allowedTags: [],
                  allowedAttributes: [],
                }
              )}
            </h3>
            <p className={'portfolio__content__subtitle'}>
              {sanitizeHtml(
                content[
                  `content.new.contract.${portfolioKey}.devices.description`
                ],
                {
                  allowedTags: [],
                  allowedAttributes: [],
                }
              )}
            </p>
            {devices && (
              <React.Fragment>
                <Field name="device_e" component={renderError} />
                <DevicesWrapper
                  devices={devices}
                  deviceMax={option.deviceMax}
                  deviceMin={option.deviceMin}
                  toggleModal={toggleModal}
                  portfolioKey={portfolioKey}
                  content={content}
                  change={change}
                  values={formData.device && formData.device[selectedPortfolio]}
                />
              </React.Fragment>
            )}
            {deviceTotal > 0 && (
              <React.Fragment>
                <hr />
                <h3 className={'portfolio__content__text'}>
                  {sanitizeHtml(
                    content[
                      `content.new.contract.${portfolioKey}.installation.title`
                    ],
                    {
                      allowedTags: [],
                      allowedAttributes: [],
                    }
                  )}
                </h3>
                <p
                  className={
                    'portfolio__content__subtitle portfolio__content__subtitle--warning'
                  }
                >
                  {sanitizeHtml(
                    content[
                      `content.new.contract.${portfolioKey}.installation.description`
                    ],
                    {
                      allowedTags: [],
                      allowedAttributes: [],
                    }
                  )}
                </p>
                <div className={'instalation'}>
                  {installations &&
                    installations.map((item, i) => (
                      <div key={item.id} className={'instalation__item'}>
                        <label
                          htmlFor={`installation_type_${i}`}
                          className={'radio'}
                        >
                          <Field
                            type="radio"
                            id={`installation_type_${i}`}
                            name="installation_type"
                            component="input"
                            onClick={() => handleInstallation(item.id)}
                            checked={
                              selectedInstallation
                                ? item.id === selectedInstallation
                                : item.selected
                            }
                            disabled={item.disabled}
                          />
                          <span>
                            {item.name}
                            <span
                              className="portfolio__content__item__info"
                              onClick={(e) => {
                                e.preventDefault()
                                toggleModal(
                                  sanitizeHtml(
                                    content[
                                      `content.new.contract.${portfolioKey}.installation.${item.id}.description`
                                    ],
                                    {
                                      allowedTags: ALLOWED_TAGS,
                                      allowedAttributes: ALLOWED_ATTRIBUTES,
                                    }
                                  )
                                )
                              }}
                            >
                              ?
                            </span>
                          </span>
                        </label>
                        {/* <div className={'installation__item__price'}>
                          +&nbsp;
                          {formatCurrency(item.priceVat, 0)}
                        </div> */}
                      </div>
                    ))}
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
        <div className="footer--note small-note">
          {content['content.account.services.new.legal.1'] && (
            <p
              dangerouslySetInnerHTML={{
                __html: content['content.account.services.new.legal.1'],
              }}
            />
          )}

          {/* {content['content.account.services.new.legal.2'] && (
              <p
                dangerouslySetInnerHTML={{
                  __html: content['content.account.services.new.legal.2'],
                }}
              />
            )} */}
        </div>
        <div className="footline footline--activation footline--activation--1 footline--btn">
          <button
            disabled={submitting}
            className="btn btn--primary btn--wideboi"
            type="submit"
            // onClick={() => handleSubmitStep1()}
          >
            Pokračovat
          </button>
        </div>
      </form>
    )
  }
}

ServiceUpsellForm = reduxForm({
  form: 'service_upsell_form',
  touchOnBlur: false,
  //touchOnChange: false,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(ServiceUpsellForm)

export default ServiceUpsellForm
